import './ContactsBar.css'

const ContactsBar = () =>
{
	
	return (
		<div className="contactsBar-main-container" >
            <div className='contactsBar-first-column'>
                <img className='contactsBar-main-logo' src='https://www.digitalreti.com/wp-content/uploads/2021/05/logo.png' alt='logo'></img>
                <div className='contactsBar-text'>
                    Digitalreti Srl<br></br>
                    <b>Sede Legale e Amministrativa</b><br></br>
                    Via Milano, 62<br></br>
                    30020 Marcon (VE)<br></br>
                    P.Iva: 04285530277<br></br>
                    SDI: 7HE8RN5<br></br>
                    Pec: digitalreti@pec.it<br></br>
                    <a className='contactsBar-text' href='mailto:info@digitalreti.com'>info@digitalreti.com</a>
                    <div className='contactsBar-row'>
                        <img className='contactsBar-number-logo' src='/assets/simple-phone.png' alt='phone'></img>
                        <a className='contactsBar-text' href='tel:04211765101'>Tel. Amministrazione : +39 0421 1765101</a>
                    </div>
                </div>
                <div className='contactsBar-text'>
                    <b>Sede Commerciale e Tecnica</b><br></br>
                    Via Borsoi, 63/2<br></br>
                    30023 Concordia Sagittaria (VE)<br></br>
                    <div className='contactsBar-row'>
                        <img className='contactsBar-number-logo' src='/assets/simple-phone.png' alt='phone'></img>
                        <a className='contactsBar-text' href='tel:04211765101'>Tel. Commerciale : +39 0421 1765101</a>
                    </div>
                    <div className='contactsBar-row'>
                        <img className='contactsBar-number-logo' src='/assets/simple-phone.png' alt='phone'></img>
                        <a className='contactsBar-text' href='tel:04211765103'>Tel. Rep. Tecnico : +39 0421 1765103</a>
                    </div>
                </div>
                <div className='contactsBar-row'>
                    <a href='https://www.linkedin.com/company/digital-reti/'><img className='contactsBar-social-logo' src='/assets/linkedin.png' alt='linkedin'></img> </a>
                    <a href='https://www.facebook.com/DigitalRetiBusiness/'><img className='contactsBar-social-logo' src='/assets/facebook.png' alt='facebook'></img></a>
                    <a href='https://www.instagram.com/digital_reti/'><img className='contactsBar-social-logo' src='/assets/instagram.png' alt='instagram'></img></a>
                    <a href='https://wa.me/3202997792?text=Salve,%20vorrei%20richiedere%20maggiori%20informazioni!'><img className='contactsBar-social-logo' src='/assets/whatsapp.png' alt='whatsapp'></img></a>
                </div>
            </div>
            <div className='contactsBar-second-column'>
                <div className='contactsBar-title'>Link Utili</div>
                <a href={`${process.env.REACT_APP_SITE_URL}`} className='contactsBar-text'>Home Page</a>
                <a href={`${process.env.REACT_APP_SITE_URL}/chi-siamo/`} className='contactsBar-text'>Chi Siamo</a>
                <a href={`${process.env.REACT_APP_SITE_URL}/servizi/`} className='contactsBar-text'>Servizi</a>
                <a href={`${process.env.REACT_APP_SITE_URL}/contatti/`} className='contactsBar-text'>Contatti</a>
            </div>
            <a className='contactsBar-greenNumber-logo' href='tel:+39800911639'><img src='https://www.digitalreti.com/wp-content/uploads/2021/05/numero-verde-300x122.png' alt='green number'></img></a>
		</div>
	)
}

export default ContactsBar
